import { UserGameProfile } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const saveUserGameProfile = createAction(
  '[UserGameProfile Page] SaveUserGameProfile',
  props<{ userGameProfile: UserGameProfile }>(),
);

export const saveUserGameProfileSuccess = createAction(
  '[UserGameProfile/API] SaveUserGameProfile Success',
  props<{ userGameProfile: UserGameProfile }>(),
);

export const saveUserGameProfileFailure = createAction(
  '[UserGameProfile/API] SaveUserGameProfile Failure',
  props<{ error: any; userGameProfile: UserGameProfile }>(),
);

export const requireVerification = createAction(
  '[UserGameProfile/API] Require User Verification',
  props<{ userGameProfile: UserGameProfile }>(),
);
